/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { FunctionComponent } from 'preact';
import { Skeleton, SkeletonRow } from '@adobe-commerce/elsie/components';

export const CartItemSkeleton: FunctionComponent = () => {
  return (
    <div className="dropin-cart-item dropin-cart-item-skeleton">
      <Skeleton className="dropin-cart-item__skeleton dropin-cart-item__wrapper">
        <div className="dropin-cart-item__image">
          <SkeletonRow className="dropin-cart-item__skeleton__item" />
        </div>
        <div className="dropin-cart-item__title">
          <SkeletonRow className="dropin-cart-item__skeleton__item" />
        </div>
        <div className="dropin-cart-item__sku">
          <SkeletonRow className="dropin-cart-item__skeleton__item" />
        </div>
        <div className="dropin-cart-item__price">
          <SkeletonRow className="dropin-cart-item__skeleton__item" />
        </div>
        <div className="dropin-cart-item__quantity">
          <SkeletonRow className="dropin-cart-item__skeleton__item" />
        </div>
        <div className="dropin-cart-item__total">
          <SkeletonRow className="dropin-cart-item__skeleton__item" />
        </div>
      </Skeleton>
    </div>
  );
};
